import { VideoProvider } from '../models/FeatureFlags';

type FeatureFlagsState = Record<string, string | boolean>;

const defaultState: FeatureFlagsState = {
  hideLiveChat: false,
  hideVisitCount: false,
  hpiSessionInvoice: false,
  enableOnlineForLiveCoaching: false,
  videoProvider: VideoProvider.Tokbox,
  invoicingDashboard: false,
  hideProviderCalendaring: true,
  viewDebugInfo: false,
  rosterForTherapists: false,
  showNewTopicsProvider: false,
  showHpiClientStatusInfo: false,
  showMemberPhq9SelfharmScore: false,
  bookSessionOnQuarterInterval: false,
};

export const featureFlags = {
  state: defaultState,
  reducers: {
    saveFlags: (state: FeatureFlagsState, newFlags: FeatureFlagsState): FeatureFlagsState => {
      return {
        ...state,
        ...newFlags,
      };
    },
  },
};
